import React from 'react';

function VisaIcon() {
  return (
    <svg width="44" height="15" viewBox="0 0 44 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M19.241 14.489H15.7085L17.918 0.748734H21.4503L19.241 14.489Z" fill="#00579F" />
      <path
        d="M32.0458 1.08498C31.349 0.806964 30.2439 0.5 28.8774 0.5C25.3889 0.5 22.9324 2.37092 22.9173 5.04578C22.8883 7.01928 24.6761 8.11541 26.0133 8.77344C27.3799 9.44585 27.8445 9.88473 27.8445 10.4841C27.8306 11.4046 26.7402 11.8289 25.7231 11.8289C24.3128 11.8289 23.5571 11.6101 22.4087 11.098L21.9435 10.8785L21.4492 13.9629C22.2777 14.3425 23.8042 14.6794 25.3889 14.6941C29.0955 14.6941 31.5086 12.8522 31.5372 10.0017C31.5513 8.43753 30.6072 7.23901 28.572 6.25965C27.3365 5.63095 26.5798 5.20703 26.5798 4.56377C26.5943 3.97898 27.2198 3.38002 28.6145 3.38002C29.7629 3.35068 30.6067 3.62831 31.2459 3.90613L31.5654 4.05203L32.0458 1.08498Z"
        fill="#00579F"
      />
      <path
        d="M36.7422 9.62133C37.0331 8.83197 38.1526 5.77691 38.1526 5.77691C38.1379 5.80625 38.4429 4.97298 38.6173 4.46144L38.8642 5.64538C38.8642 5.64538 39.5332 8.93436 39.6784 9.62133C39.1263 9.62133 37.44 9.62133 36.7422 9.62133ZM41.1027 0.748734H38.3703C37.5277 0.748734 36.8875 0.997024 36.5239 1.88877L31.2769 14.4888H34.9834C34.9834 14.4888 35.5936 12.793 35.7248 12.4277C36.1314 12.4277 39.7371 12.4277 40.2602 12.4277C40.3617 12.9101 40.6817 14.4888 40.6817 14.4888H43.9525L41.1027 0.748734Z"
        fill="#00579F"
      />
      <path
        d="M12.7581 0.748734L9.29858 10.1183L8.92055 8.21805C8.28096 6.0254 6.27508 3.64313 4.03662 2.4586L7.20539 14.4745H10.9409L16.4934 0.748734H12.7581Z"
        fill="#00579F"
      />
      <path
        d="M6.08584 0.748734H0.402382L0.344238 1.02639C4.77769 2.16676 7.71388 4.91556 8.92023 8.21949L7.68471 1.90387C7.48131 1.0262 6.8562 0.777685 6.08584 0.748734Z"
        fill="#FAA61A"
      />
    </svg>
  );
}

export default VisaIcon;
